import {
  cameraEntryActionTypes as types,
} from "./cameraEntryTypes";
import { cameraEntryState } from "./cameraEntryTypes";

export const INIT_STATE: cameraEntryState = {
  imageBlob: null,
  imagePreviewUrl: null,

  processingStatus: "idle",
  sqlResult: "",
  entryResult: "",
  errorMessage: "",

  loading: false,
  error: "",
};

const cameraEntryReducer = (
  state = INIT_STATE,
  action: any
): cameraEntryState => {
  switch (action.type) {
    /* ---------- API SUCCESS ---------- */
    case types.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case types.SUBMIT_IMAGE_ENTRY:
          return {
            ...state,
            sqlResult: action.payload.data.sqlResult,
            entryResult: action.payload.data.entryResult,
            errorMessage: "",
            loading: false,
            processingStatus: "done",
          };
        default:
          return { ...state, loading: false };
      }

    /* ---------- API ERROR ---------- */
    case types.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case types.SUBMIT_IMAGE_ENTRY:
          return {
            ...state,
            errorMessage: action.payload.error,
            sqlResult: "",
            entryResult: "",
            loading: false,
            processingStatus: "idle",
          };
        default:
          return {
            ...state,
            loading: false,
            error: action.payload?.error ?? "Unknown error",
          };
      }

    /* ---------- BASIC STATE ---------- */
    case types.SET_IMAGE_BLOB:
      return { ...state, imageBlob: action.payload };

    case types.SET_IMAGE_PREVIEW_URL:
      return { ...state, imagePreviewUrl: action.payload };

    case types.SET_PROCESSING_STATUS:
      return { ...state, processingStatus: action.payload };

    case types.SUBMIT_IMAGE_ENTRY:
      return { ...state, loading: true };

    case types.CLEAR_ENTRY_RESULTS:
      return { ...state, sqlResult: "", entryResult: "" };

    case types.SET_ERROR_MESSAGE:
      return { ...state, errorMessage: action.payload };

    default:
      return state;
  }
};

export default cameraEntryReducer;
